import { render, staticRenderFns } from "./FormBuilderFieldConfig.vue?vue&type=template&id=10a6e13e&scoped=true"
import script from "./FormBuilderFieldConfig.vue?vue&type=script&lang=js"
export * from "./FormBuilderFieldConfig.vue?vue&type=script&lang=js"
import style0 from "./FormBuilderFieldConfig.vue?vue&type=style&index=0&id=10a6e13e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a6e13e",
  null
  
)

export default component.exports